import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SignalLayout from './SignalLayout';
import SignalIndexPage from './SignalIndexPage';
import SignalScreenPage from './SignalScreenPage';

/**
 * Is the Signal System redesign preview enabled?
 *
 * On by default in dev so the screens are one URL away while they are being
 * built; in a production build it requires VITE_SIGNAL_UI=true.
 */
export const isSignalUiEnabled = (): boolean => {
  const flag = import.meta.env.VITE_SIGNAL_UI;
  if (flag !== undefined) return flag === 'true' || flag === '1';
  return import.meta.env.DEV;
};

/** Route definitions for the Signal surfaces. */
export const signalRoutes = (
  <Route path="/signal" element={<SignalLayout />}>
    <Route index element={<SignalIndexPage />} />
    <Route path=":screenId" element={<SignalScreenPage />} />
  </Route>
);

/**
 * The Signal preview as a standalone route tree.
 *
 * Mounted in App.tsx *outside* ProtectedRoute and Layout: these screens are
 * self-contained mockups with no queries behind them, so requiring a login and
 * then wrapping them in the app's existing chrome would only get in the way of
 * reviewing the design.
 */
export const SignalPreviewRoutes: React.FC = () => (
  <Routes>{signalRoutes}</Routes>
);

export { SignalLayout, SignalIndexPage, SignalScreenPage };
export { signalScreens, findSignalScreen } from './screens/registry';
export type { SignalScreenDef } from './screens/registry';
